const invoicesEn = {
  "inv.title": "Invoices",
  "inv.nav_hint": "Tax invoices, credit notes and their layout",
  "inv.description": "Tax invoices are issued for orders automatically and numbered without gaps. Once issued they never change: refunds get a credit note.",
  "inv.missing_legal": "Add your legal business name and tax registration number so they print on invoices.",
  "inv.store_profile": "Go to Store profile",
  "inv.issuing": "Issuing",
  "inv.issue_on": "Issue an invoice",
  "inv.issue_on.paid": "When the order is paid",
  "inv.issue_on.paid_hint": "Card payments at checkout; cash on delivery and bank transfer once you mark them paid.",
  "inv.issue_on.fulfilled": "When the order is fulfilled",
  "inv.issue_on.fulfilled_hint": "When the first items are shipped or handed over.",
  "inv.issue_on.manual": "Only when I issue it",
  "inv.issue_on.manual_hint": "Issue invoices yourself from the order page.",
  "inv.email_customer": "Email the invoice to the customer",
  "inv.email_customer_hint": "They get a link to download the PDF. They can also download it from their order page.",
  "inv.bilingual": "Print headings in English and Arabic",
  "inv.bilingual_hint": "Required in Saudi Arabia and recommended across the Gulf.",
  "inv.numbering": "Numbering",
  "inv.invoice_prefix": "Invoice prefix",
  "inv.credit_prefix": "Credit note prefix",
  "inv.prefix_hint": "{year} becomes the year. Next number looks like {example}.",
  "inv.numbering_hint": "Numbers run in order without gaps. Changing a prefix only affects new invoices.",
  "inv.notes": "Notes on every invoice",
  "inv.notes_hint": "For example payment terms, bank details or a thank-you.",
  "inv.template": "Layout",
  "inv.template_hint": "The invoice is an HTML page with Liquid tags. The amounts, numbers and tax details come from the issued invoice; the layout decides how they look.",
  "inv.template_code": "Template",
  "inv.preview": "Preview",
  "inv.register": "Issued invoices",
  "inv.register_hint": "Every invoice and credit note. Export them for your accountant.",
  "inv.export": "Export CSV",
  "inv.from": "From",
  "inv.to": "To",
  "inv.none": "No invoices yet.",
  "inv.number": "Number",
  "inv.order": "Order",
  "inv.customer": "Customer",
  "inv.date": "Date",
  "inv.tax": "Tax",
  "inv.total": "Total",
  "inv.credit_note": "Credit note",
  "inv.invoice": "Tax invoice",
  "inv.download": "Download {number}",
  "inv.order_card": "Invoices",
  "inv.order_none": "No invoice has been issued for this order yet.",
  "inv.issue": "Issue invoice",
  "inv.issued": "Invoice {number} issued",
  "inv.credit_for": "Credit note for {number}",
  "inv.einvoice.pending": "E-invoice pending",
  "inv.einvoice.submitted": "E-invoice submitted",
  "inv.einvoice.accepted": "E-invoice accepted",
  "inv.einvoice.rejected": "E-invoice rejected",
} as const;

export default invoicesEn;
